export default function ThreeStepProcessSection() {
  return (
    <section id="process" className="py-20 bg-gradient-to-br from-teal-600 to-teal-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Our Simple 3-Step Process
          </h2>
          <p className="text-xl text-teal-50 max-w-3xl mx-auto leading-relaxed">
            Selling your land for cash is straightforward and transparent. Here's exactly how it works from start to finish.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white rounded-lg p-8 shadow-xl relative">
            <div className="absolute -top-6 left-8 w-12 h-12 bg-teal-600 text-white rounded-full flex items-center justify-center text-2xl font-bold">
              1
            </div>
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-6 mt-4">
              <i className="ri-phone-line text-teal-600 text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">Contact Us</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              Call us at (915) 206-5814 or fill out our online form. Tell us about your land - location, size, condition, and any special circumstances. This initial conversation takes just 5-10 minutes.
            </p>
            <p className="text-gray-700 leading-relaxed">
              We'll ask basic questions like: Where is the property located? What's the approximate acreage? Are there any access issues, liens, or title problems? Do you have a timeline for selling?
            </p>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-xl relative">
            <div className="absolute -top-6 left-8 w-12 h-12 bg-teal-600 text-white rounded-full flex items-center justify-center text-2xl font-bold">
              2
            </div>
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-6 mt-4">
              <i className="ri-search-line text-teal-600 text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">Property Evaluation</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              We'll research your property using county records, GIS mapping, and comparable sales data. In most cases, we can make an offer without even visiting the property. If needed, we'll schedule a quick site visit at your convenience.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Our evaluation considers: current market value, zoning and development potential, access and utilities, any liens or encumbrances, and comparable recent sales. Within 24 hours, we'll present you with a fair, no-obligation cash offer.
            </p>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-xl relative">
            <div className="absolute -top-6 left-8 w-12 h-12 bg-teal-600 text-white rounded-full flex items-center justify-center text-2xl font-bold">
              3
            </div>
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-6 mt-4">
              <i className="ri-file-text-line text-teal-600 text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">Close on Your Timeline</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              If you accept our offer, we'll open escrow with a reputable title company. We handle all the paperwork, pay all closing costs, and work around your schedule. Need to close in 7 days? No problem. Need 30 days? That works too.
            </p>
            <p className="text-gray-700 leading-relaxed">
              At closing, you'll sign the deed, and we'll wire your cash payment directly to your bank account. No waiting for checks to clear. No last-minute surprises. Just a smooth, professional transaction from start to finish.
            </p>
          </div>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 border-2 border-white/20">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-4 text-white">Why Our Process Works</h3>
              <p className="text-teal-50 leading-relaxed mb-4">
                We've purchased over 200 land parcels in El Paso and surrounding areas since 2016. Our streamlined process eliminates the uncertainty and delays of traditional sales.
              </p>
              <p className="text-teal-50 leading-relaxed mb-6">
                Unlike wholesalers who assign contracts or realtors who list properties, we are the actual end buyers. We have the cash ready and the experience to close quickly, even on complicated properties.
              </p>
              <a 
                href="tel:+1-915-206-5814" 
                className="inline-flex items-center space-x-2 px-6 py-3 bg-white text-teal-600 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill"></i>
                <span>Start Your Sale Today</span>
              </a>
            </div>
            <div className="w-full h-80 rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/31d3757f26dc4653d24c53e954eaef1a.jpg"
                alt="Land sale closing process"
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}